import { config } from "../../config";
import { TransferPage as TransferPageA } from "./flavor-a/TransferPage";
import { TransferPage as TransferPageB } from "./flavor-b/TransferPage";
import { TransferPage as TransferPageC } from "./flavor-c/TransferPage";

export const TransferPageRouter = () => {
  if (config.TRANSFER_FLAVOR === "B") return <TransferPageB />;
  if (config.TRANSFER_FLAVOR === "C") return <TransferPageC />;
  return <TransferPageA />;
};
